import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wpcm-amount-box" }
const _hoisted_2 = { class: "wpcm-donation-amt-fields" }
const _hoisted_3 = {
  key: 0,
  class: "el-custom-select"
}
const _hoisted_4 = {
  key: 1,
  class: ""
}
const _hoisted_5 = {
  key: 2,
  class: "wpcm-pre-dfind-amt"
}
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.show_currency_dropdown && $props.currencies)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_select, {
              class: "w-100",
              value: $setup.currency,
              onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.setValue('currency', $event)))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.currencies, (curr, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: key,
                    key: key,
                    label: curr
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(curr), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value"])
          ]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "donation_dropdowns"),
      ($props.strings)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createCommentVNode(" <strong class=\"wpcm-cstm-amt-txt\">{{\n\t\t\t\t\tstrings.how_much\n\t\t\t\t}}</strong> ")
          ]))
        : _createCommentVNode("v-if", true),
      ($props.show_amounts && $props.amounts)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.amounts, (amnt) => {
              return (_openBlock(), _createElementBlock("li", {
                key: amnt,
                onClick: _withModifiers(($event: any) => ($setup.store.amount = $setup.convert(amnt)), ["prevent"])
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass([
              'wpdonation-button',
              $setup.store.amount == amnt && 'active'
            ])
                }, _toDisplayString($setup.getSymbol()) + _toDisplayString(amnt), 3 /* TEXT, CLASS */)
              ], 8 /* PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}